import { I18n } from '@calendly/i18n';
import { BrandLogo } from '@calendly/ui/components/brand-logo';
import { AlertWarningTriangleIcon } from '@calendly/ui/components/icons';
import { colorIconWarning } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Header as CardHeader, Logo as CardLogo } from '../integration_card';
const emptyLogoCss = "er94gvc";
const EmptyLogo = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(emptyLogoCss, props.className)}>
      <AlertWarningTriangleIcon color={colorIconWarning} size="x-large" />
    </Component>;
});
export const headerId = (provider = null) => {
  switch (provider) {
    case 'google':
      return 'header-google-calendar';
    case 'outlook':
      return 'header-microsoft-outlook-calendar';
    case 'exchange':
      return 'header-microsoft-exchange';
    case 'icloud':
      return 'header-icloud-calendar';
    case 'outlook_desktop':
      return 'header-outlook-desktop-calendar';
    default:
      return null;
  }
};
const EmptyProviderHeader = ({
  title,
  subtitle
}) => <CardHeader title={title || I18n.t('publisher.availability_settings.section.calendar_settings.adding_events.calendar_not_selected')} subtitle={subtitle || I18n.t('publisher.availability_settings.section.calendar_settings.adding_events.do_not_add_events')} />;
const GoogleProviderHeader = ({
  title,
  subtitle,
  id
}) => <CardHeader id={id} title={title || I18n.t('publisher.calendar.google.title')} subtitle={subtitle || I18n.t('publisher.calendar.google.compatibility')} />;
const OutlookProviderHeader = ({
  title,
  subtitle,
  id
}) => <CardHeader id={id} title={title || I18n.t('publisher.calendar.outlook.title')} subtitle={subtitle || I18n.t('publisher.calendar.outlook.compatibility')} />;
const ExchangeProviderHeader = ({
  title,
  subtitle,
  id
}) => <CardHeader id={id} title={title || I18n.t('publisher.calendar.exchange.title')} subtitle={subtitle || I18n.t('publisher.calendar.exchange.compatibility')} />;
const IcloudProviderHeader = ({
  title,
  subtitle,
  id
}) => <CardHeader id={id} title={title || I18n.t('publisher.calendar.icloud.title')} subtitle={subtitle || I18n.t('publisher.calendar.icloud.compatibility')} />;
const OutlookDesktopProviderHeader = ({
  title,
  subtitle,
  id
}) => <CardHeader id={id} title={title || I18n.t('publisher.calendar.outlook_desktop.title')} subtitle={subtitle || I18n.t('publisher.calendar.outlook_desktop.compatibility')} />;
export const ProviderHeader = ({
  provider,
  title,
  subtitle,
  id
}) => {
  switch (provider) {
    case 'google':
      return <GoogleProviderHeader title={title} subtitle={subtitle} id={id} />;
    case 'outlook':
      return <OutlookProviderHeader title={title} subtitle={subtitle} id={id} />;
    case 'exchange':
      return <ExchangeProviderHeader title={title} subtitle={subtitle} id={id} />;
    case 'icloud':
      return <IcloudProviderHeader title={title} subtitle={subtitle} id={id} />;
    case 'outlook_desktop':
      return <OutlookDesktopProviderHeader title={title} subtitle={subtitle} id={id} />;
    default:
      return <EmptyProviderHeader title={title} subtitle={subtitle} />;
  }
};
export const ProviderLogo = ({
  provider
}) => {
  switch (provider) {
    case 'google':
      return <CardLogo icon={<BrandLogo name="google-calendar" />} />;
    case 'outlook':
      return <CardLogo icon={<BrandLogo name="microsoft-outlook-calendar" />} />;
    case 'exchange':
      return <CardLogo icon={<BrandLogo name="microsoft-exchange" />} />;
    case 'icloud':
      return <CardLogo icon={<BrandLogo name="apple" />} />;
    case 'outlook_desktop':
      return <CardLogo icon={<BrandLogo name="microsoft-outlook-calendar" />} />;
    default:
      return <CardLogo icon={<EmptyLogo />} />;
  }
};

require("./header.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./header.js");